export default "__VITE_ASSET__BL2Nj3UY__"